import PropTypes from "prop-types"
import { Tabs, Tab, Card, Select, MenuItem } from "@mui/material"

const DataLibrarySettings = ({ scope, changeScope, currentTab, changeTab }) => {
  return <Card className="library-settings" square elevation={1}>
    <Select
      variant="standard"
      labelId="scope"
      id="scope"
      className="fixed no-underline"
      value={scope}
      onChange={changeScope}
    >
      <MenuItem value="subscriptions">Subscriptions</MenuItem>
      <MenuItem value="proprietary">Proprietary</MenuItem>
    </Select>
    {scope === "subscriptions"
      && <Tabs
        aria-label="Data cloud view"
        indicatorColor="primary"
        textColor="primary"
        value={currentTab}
        className="horizontal-menu"
        onChange={changeTab}
      >
        <Tab value="browse" label="Browse" />
        <Tab value="active" label="Active" />
      </Tabs>}
    {scope === "proprietary"
      && <Tabs
        aria-label="Data cloud view"
        indicatorColor="primary"
        textColor="primary"
        value={currentTab}
        className="horizontal-menu"
        onChange={changeTab}
      >
        <Tab value="indicators" label="Indicators" />
        <Tab value="classifications" label="Classifications" />
      </Tabs>}

  </Card>
}

DataLibrarySettings.propTypes = {
  scope: PropTypes.string.isRequired,
  currentTab: PropTypes.string.isRequired,
  changeScope: PropTypes.func.isRequired,
  changeTab: PropTypes.func.isRequired,
}

export default DataLibrarySettings
